module.exports = __webpack_public_path__ + "img/change-password-th.123f799.png";